import { useNavigation } from "@react-navigation/native"
import { cloneDeep } from "lodash"
import React, { useMemo, useState } from "react"
import { ScrollView, StyleSheet, Text, View } from "react-native"
import { useMediaQuery } from "react-responsive"

import Base, { Firebase } from "../../../../base"
import { TextField } from "../../../common"
import Gap from "../../../common/Gap"
import { useSettingsColumnStyles } from "../../styles"
import CategoryRow from "../detail/CategoryRow"
import ItemRow from "../detail/ItemRow"

export default function MenuView(props) {
  const navigation = useNavigation()
  const allItems = useMemo(() => Base.functions.getAllMenuItems(props.menu), [
    props.menu,
  ])

  const [searchQuery, setSearchQuery] = useState("")
  const isMobile = useMediaQuery(Base.constants.mobile)

  function itemPressed(item) {
    navigation.navigate("MenuDetails", { item, itemId: item._id })
  }

  function searchQueryChanged(query) {
    query = query || ""
    setSearchQuery(query)
    if (query.length > 2) {
      Firebase.logEvent("menu_search", { query })
    }
  }

  const isFlooid = useMemo(() => props?.menu?.provider === "Flooid", [props])

  const searchResults = useMemo(() => {
    if (!searchQuery.length) {
      return []
    }
    const data = cloneDeep(allItems)

    return data.filter(item =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase()),
    )
  }, [allItems, searchQuery])

  const containerStyles = useSettingsColumnStyles()

  return (
    <ScrollView
      style={[containerStyles, props.style]}
      showsVerticalScrollIndicator={false}
    >
      {!isMobile && (
        <Text style={[Base.styles.title_md, styles.title]}>Menu Stock</Text>
      )}
      <TextField placeholder="Search" onChangeText={searchQueryChanged} />
      <View>
        {!props.menu?.categories?.length && (
          <Text style={[Base.styles.body, styles.emptyState]}>
            No menu items to display
          </Text>
        )}

        {searchQuery.length > 2
          ? searchResults.map(item => (
              <ItemRow
                key={item?._id}
                static={true}
                item={item}
                onPress={itemPressed}
                isFlooid={isFlooid}
                onStatusChange={props.onStatusChange}
              />
            ))
          : props.menu?.categories?.map((item, i) => (
              <CategoryRow
                key={item?._id}
                static={true}
                item={item}
                onPress={itemPressed}
                onStatusChange={props.onStatusChange}
                isFlooid={isFlooid}
              />
            ))}
      </View>
      <Gap size={24} />
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  title: {
    marginVertical: 24,
  },
  emptyState: { marginTop: 10 },
})
